export default {
  ONE: 'ONE',
  TWELVE: 'TWELVE',
};
